const countries = [
    { value: "Denmark", label: "Dänemark" },
    { value: "Sweden", label: "Schweden" },
    { value: "Norway", label: "Norwegen" },
    { value: "Germany", label: "Deutschland" },
    { value: "USA", label: "USA" },
    { value: "Canada", label: "Kanada" },
    { value: "Australia", label: "Australien" },
    { value: "Andorra", label: "Andorra" },
    { value: "Austria", label: "Österreich" },
    { value: "Belgium", label: "Belgien" },
    { value: "Brazil", label: "Brasilien" },
    { value: "Cyprus", label: "Zypern" },
    { value: "Finland", label: "Finnland" },
    { value: "France", label: "Frankreich" },
    { value: "Greece", label: "Griechenland" },
    { value: "Iceland", label: "Island" },
    { value: "Ireland", label: "Irland" },
    { value: "Italy", label: "Italien" },
    { value: "Japan", label: "Japan" },
    { value: "Liechtenstein", label: "Liechtenstein" },
    { value: "Luxembourg", label: "Luxemburg" },
    { value: "Latvia", label: "Lettland" },
    { value: "Lithuania", label: "Litauen" },
    { value: "Malta", label: "Malta" },
    { value: "Monaco", label: "Monaco" },
    { value: "Netherlands", label: "Niederlande" },
    { value: "Portugal", label: "Portugal" },
    { value: "San Marino", label: "San Marino" },
    { value: "Spain", label: "Spanien" },
    { value: "Switzerland", label: "Schweiz" },
    { value: "United Kingdom", label: "Großbritannien" },
    { value: "China", label: "China" }
  ];
  
  export default countries;
  


// WEBPACK FOOTER //
// ./src/c/countries/CountriesDe.js